module.exports = __webpack_public_path__ + "static/img/61008.d8ce3623.png";